import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoCelldega = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 355.8 218.7",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: #006db6;\n      }\n\n      .st1 {\n        fill: #00afd7;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("rect", {
			className: "st1",
			x: 138.9,
			y: 4,
			width: 30.2,
			height: 51.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st0",
			x: 2.8,
			y: 4,
			width: 30.2,
			height: 51.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st0",
			x: 274.9,
			y: 4,
			width: 30.2,
			height: 51.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st1",
			x: 48.2,
			y: 4,
			width: 30.2,
			height: 51.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st1",
			x: 320.3,
			y: 4,
			width: 30.2,
			height: 51.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st1",
			x: 229.6,
			y: 4,
			width: 30.2,
			height: 51.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st0",
			x: 184.2,
			y: 4,
			width: 30.2,
			height: 51.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st0",
			x: 93.5,
			y: 4,
			width: 30.2,
			height: 51.8
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M350.3,86c-1.1,14-11.4,22.5-21.8,22.1h-.1c-10,.3-20-7.6-21.6-20.8-1.6,13.2-11.6,21.1-21.6,20.8h-.1c-10,.3-20-7.6-21.6-20.8-1.6,13.2-11.6,21.1-21.6,20.8h-.1c-10,.3-20-7.6-21.6-20.8-1.6,13.2-11.6,21.1-21.6,20.8h-.1c-10,.3-20-7.6-21.6-20.8-1.6,13.2-11.6,21.1-21.6,20.8h-.1c-10,.3-20-7.6-21.6-20.8-1.6,13.2-11.6,21.1-21.6,20.8h0c-10,.3-20-7.6-21.6-20.8-1.6,13.2-11.6,21.1-21.6,20.8h0c-10,.3-20-7.6-21.6-20.8-1.6,13.2-11.6,21.1-21.6,20.8h-.1c-10.4.3-20.7-8.1-21.8-22.1-.3-4.4-.2-12.8-.2-17.5h347.9c0,4.7,0,13.1-.2,17.5h-.7Z"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M25.8,192.3c-4.9,0-9.1-.9-12.6-2.7s-6.1-4.6-7.9-8.3c-1.8-3.8-2.7-8.6-2.7-14.4s1-11,3.1-14.8c2.1-3.8,4.9-6.6,8.6-8.4,3.7-1.8,7.9-2.7,12.7-2.7s6.4.3,8.9,1,4.7,1.5,6.6,2.4l-4,10.5c-2.1-.9-4.1-1.6-6-2.1-1.8-.5-3.7-.8-5.5-.8s-4.3.6-5.9,1.7c-1.6,1.1-2.7,2.8-3.5,5s-1.2,5-1.2,8.3.4,6,1.2,8.2c.8,2.2,2,3.8,3.6,4.8s3.5,1.6,5.7,1.6,5.3-.4,7.5-1.1c2.2-.8,4.3-1.8,6.4-3.2v11.6c-2.1,1.3-4.2,2.2-6.5,2.8s-5.1.9-8.6.9v-.3Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M70.7,140.9c4.6,0,8.6.9,11.9,2.6,3.3,1.8,5.9,4.3,7.7,7.6,1.8,3.3,2.7,7.4,2.7,12.2v6.6h-32.1c0,3.8,1.3,6.8,3.4,9,2.1,2.2,5.1,3.3,9,3.3s6.1-.3,8.7-1,5.4-1.6,8.1-2.9v10.5c-2.5,1.2-5,2.1-7.7,2.7-2.7.6-5.9.8-9.8.8s-9.4-.9-13.2-2.7-6.8-4.6-9-8.4c-2.2-3.8-3.3-8.5-3.3-14.2s1-10.6,3-14.5,4.7-6.8,8.2-8.7,7.6-2.9,12.3-2.9h.1ZM70.8,150.6c-2.6,0-4.8.8-6.6,2.5-1.7,1.7-2.7,4.3-3,7.9h19c0-2-.4-3.8-1.1-5.4-.7-1.6-1.7-2.8-3.1-3.7s-3.1-1.4-5.3-1.4h0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M115.3,191.4h-13.6v-69h13.6v69Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M140.8,191.4h-13.6v-69h13.6v69Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M168.5,192.3c-5.5,0-10.1-2.2-13.5-6.5-3.5-4.3-5.2-10.7-5.2-19.1s1.8-14.9,5.3-19.3c3.5-4.4,8.1-6.5,13.8-6.5s4.5.3,6.3,1,3.4,1.5,4.7,2.6,2.4,2.3,3.4,3.7h.4c-.2-.9-.4-2.3-.6-4.2s-.4-3.7-.4-5.7v-15.9h13.6v69h-10.4l-2.6-6.4h-.6c-.9,1.4-1.9,2.6-3.2,3.7-1.3,1.1-2.8,2-4.6,2.6-1.8.7-3.9,1-6.3,1h0ZM173.2,181.6c3.7,0,6.3-1.1,7.8-3.3s2.3-5.5,2.4-10v-1.5c0-4.8-.7-8.5-2.2-11.1s-4.2-3.8-8.3-3.8-5.3,1.3-7,3.9c-1.7,2.6-2.5,6.3-2.5,11.1s.9,8.5,2.6,11c1.7,2.5,4.1,3.7,7.2,3.7h0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M228.6,140.9c4.6,0,8.6.9,11.9,2.6,3.3,1.8,5.9,4.3,7.7,7.6s2.7,7.4,2.7,12.2v6.6h-32.1c.1,3.8,1.3,6.8,3.4,9,2.1,2.2,5.1,3.3,9,3.3s6.1-.3,8.7-1,5.4-1.6,8.1-2.9v10.5c-2.5,1.2-5,2.1-7.7,2.7-2.7.6-5.9.8-9.8.8s-9.4-.9-13.2-2.7-6.8-4.6-9-8.4-3.3-8.5-3.3-14.2,1-10.6,3-14.5,4.7-6.8,8.2-8.7,7.6-2.9,12.3-2.9h.1ZM228.7,150.6c-2.6,0-4.8.8-6.6,2.5-1.7,1.7-2.7,4.3-3,7.9h19c0-2-.4-3.8-1.1-5.4-.7-1.6-1.7-2.8-3.1-3.7-1.4-.9-3.1-1.4-5.3-1.4h.1Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M274.1,213.3c-6.9,0-12.2-1.2-15.9-3.6-3.7-2.4-5.5-5.8-5.5-10.1s.9-5.5,2.8-7.5,4.6-3.4,8.2-4.3c-1.4-.6-2.6-1.6-3.6-2.9-1-1.3-1.6-2.8-1.6-4.3s.5-3.5,1.6-4.7c1.1-1.3,2.7-2.5,4.8-3.7-2.6-1.1-4.7-2.9-6.2-5.4s-2.3-5.4-2.3-8.8.8-6.7,2.4-9.2,3.9-4.5,6.9-5.8,6.7-2,11.1-2,2,0,3.2.2c1.2.1,2.3.3,3.4.4,1,.1,1.7.3,2.1.4h17.3v6.9l-7.8,2c.7,1.1,1.2,2.3,1.6,3.5s.5,2.6.5,3.9c0,5.3-1.9,9.5-5.6,12.4s-8.9,4.5-15.5,4.5-3.1-.2-4.4-.4c-.7.5-1.2,1.1-1.6,1.7-.4.6-.5,1.2-.5,1.9s.3,1.2.8,1.6c.5.4,1.4.8,2.5,1s2.5.3,4.2.3h8.4c5.5,0,9.6,1.2,12.5,3.5s4.3,5.8,4.3,10.3-2.4,10.3-7.3,13.5c-4.8,3.2-11.8,4.8-20.9,4.8h.1ZM274.7,204.4c3.2,0,6-.3,8.3-.9,2.3-.6,4.1-1.5,5.4-2.6,1.2-1.1,1.9-2.4,1.9-4s-.4-2.2-1.1-2.9-1.8-1.2-3.3-1.5-3.3-.4-5.6-.4h-7c-1.7,0-3.2.3-4.5.8s-2.4,1.3-3.1,2.2c-.8,1-1.2,2.1-1.2,3.3,0,1.9.9,3.3,2.7,4.4,1.8,1.1,4.3,1.6,7.5,1.6h0ZM276.9,166.8c2.5,0,4.4-.8,5.6-2.3s1.8-3.7,1.8-6.4-.6-5.2-1.8-6.7c-1.2-1.5-3.1-2.2-5.5-2.2s-4.4.7-5.6,2.2-1.9,3.7-1.9,6.7.6,4.8,1.8,6.4c1.2,1.6,3.1,2.3,5.6,2.3Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M329.1,140.9c6.7,0,11.8,1.4,15.3,4.3,3.6,2.9,5.3,7.3,5.3,13.2v33h-9.5l-2.6-6.7h-.4c-1.4,1.8-2.9,3.2-4.4,4.3s-3.2,2-5.1,2.5-4.3.8-7,.8-5.6-.6-7.9-1.7-4.2-2.8-5.5-5.2c-1.3-2.3-2-5.3-2-8.8,0-5.3,1.9-9.1,5.6-11.6s9.3-3.9,16.7-4.1l8.6-.3v-2.2c0-2.6-.7-4.5-2-5.7-1.4-1.2-3.3-1.8-5.7-1.8s-4.8.3-7.1,1c-2.3.7-4.6,1.5-6.9,2.6l-4.5-9.1c2.6-1.4,5.6-2.5,8.9-3.3s6.7-1.2,10.2-1.2ZM336.3,168.5l-5.2.2c-4.4.1-7.4.9-9.1,2.3-1.7,1.4-2.6,3.4-2.6,5.7s.6,3.5,1.8,4.4c1.2.9,2.8,1.3,4.8,1.3,2.9,0,5.4-.9,7.4-2.6,2-1.7,3-4.2,3-7.3v-4.1h0Z"
			})
		] })
	]
});
export default SvgLogoCelldega;
